import { useUpdateEffect } from '@cian/react-utils';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { flatInfinityOffersSelector } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/selectors';

export function useUpdateSeoAfterDataChange(): void {
  const { data } = useSearchOffersDesktopQuery({ notifyOnChangeProps: ['data'], select: flatInfinityOffersSelector });
  const seoUrl = data?.pages[0].seo;

  useUpdateEffect(() => {
    if (!seoUrl) {
      return;
    }

    document.title = seoUrl.tech.tabTitle;

    const newUrl = new URL(seoUrl.tech.fullUrl);

    history.pushState(null, '', `${newUrl.pathname}${newUrl.search}`);
  }, [seoUrl?.tech.fullUrl]);
}
